"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _RendererContext = require("./RendererContext");

var __jsx = _react["default"].createElement;

/**
 * @param {{
 * tools: any[]
 * document: DocumentJson
 * language: {name: string, key: string}
 * renderer: any
 * }} param0
 */
function ContentRenderer(_ref) {
  var tools = _ref.tools,
      document = _ref.document,
      language = _ref.language,
      Renderer = _ref.renderer;
  var contextValue = {
    document: document,
    tools: tools,
    language: language
  };
  return __jsx(_RendererContext.RendererContext.Provider, {
    value: contextValue
  }, __jsx(Renderer, null));
}

var _default = ContentRenderer;
exports["default"] = _default;